import { CA_TYPE } from '@yuanfudao/metis-unified-login/es/constants/login'
import uniqueIds from '@/config/unique-ids.json'

export function getUniqueId() {
  return window.UNIQUE_ID
}

export const UNIQUE_ID_TO_CA = {
  [uniqueIds.FEIXIANG_UNIQUE_ID.id]: CA_TYPE.FEIXIANG,
  [uniqueIds.FLYING_UNIQUE_ID.id]: CA_TYPE.FLYING,
}
